/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.EmployeeCategories {
  angular.module("meevo.plugins.employeeCategories", []);
}